module.exports = __webpack_public_path__ + "assets/penis-a54f60b5d16d8b8f36fa5fa153826234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/penis.jpg
// module id = 521
// module chunks = 1